/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $Success = {
    properties: {
        yearStart: {
            type: 'number',
            isRequired: true,
        },
        yearEnd: {
            type: 'any-of',
            contains: [{
                type: 'number',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        successType: {
            type: 'SuccessType',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        teamId: {
            type: 'number',
            isRequired: true,
        },
        text: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
